/**
 * Function which performms no operation.
 */
export function noOp() {
  // does nothing (no operation)
}
